<rt-icon [name]="name()" [colorToken]="color()" [size]="size()" />
